module.exports = __webpack_public_path__ + "static/discount3-14532476737a595713c041d481c66a42.jpg";